<template>
    <v-carousel
        height="auto"
        v-model="onboarding"
        :continuous="true"
        :show-arrows="false"
        hide-delimiters
        :cycle="cycle"
    >
        <v-list
            class="pa-2 ma-0"
            style="
                background: rgba(0, 0, 0, 0.5);
                text-align: center;
                display: inline-block;
                width: 100%;
                position: absolute;
                z-index: 99;
                bottom: 0px;
            "
        >
            <div style="position: absolute"></div>

            <v-list-item>
                <v-list-item-content class="pa-0 ma-0">
                    <v-card-actions class="justify-space-between">
                        <v-btn text @click="prev" aria-label="poprzedni slajd">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-item-group
                            v-model="onboarding"
                            class="text-center"
                            mandatory
                        >
                            <v-item>
                                <v-btn
                                    icon
                                    small
                                    fab
                                    v-model="slideHandler"
                                    @click="cycle = !cycle"
                                    aria-label="włącz lub wyłącz odtwarzanie slajdu"
                                >
                                    <v-icon v-if="sliderLabel == 'play'"
                                        >mdi-play</v-icon
                                    >
                                    <v-icon v-if="sliderLabel == 'stop'"
                                        >mdi-pause</v-icon
                                    >
                                </v-btn>
                            </v-item>
                            <v-item
                                v-for="slide in sliderData"
                                :key="slide.id"
                                v-slot="{ active, toggle }"
                            >
                                <v-btn
                                    tabindex="-1"
                                    aria-label="bieżący slajd"
                                    :input-value="active"
                                    icon
                                    @click="toggle"
                                >
                                    <v-icon>mdi-record</v-icon>
                                </v-btn>
                            </v-item>
                        </v-item-group>
                        <v-btn
                            class="mr-4"
                            text
                            @click="next"
                            aria-label="następny slajd"
                        >
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-carousel-item v-for="(slide, i) in sliderData" :key="i">
            <a :href="slide.url">
                <img
                    v-if="
                        $vuetify.breakpoint.name == 'xl' ||
                        $vuetify.breakpoint.name == 'lg' ||
                        $vuetify.breakpoint.name == 'md'
                    "
                    :src="'/uploads/slider/xl/' + slide.xl"
                    :alt="slide.alt"
                    aspect-ratio="16/9"
                    cover
                    width="100%"
                    :href="slide.url"
                />
                <img
                    v-if="
                        $vuetify.breakpoint.name == 'sm' ||
                        $vuetify.breakpoint.name == 'xs'
                    "
                    :src="'/uploads/slider/sm/' + slide.sm"
                    :alt="slide.alt"
                    aspect-ratio="16/9"
                    cover
                    width="100%"
                />
            </a>
        </v-carousel-item>
    </v-carousel>
</template>
<script>
export default {
    data() {
        return {
            length: "0",
            onboarding: 0,
            sliderData: [],
            isPlay: true,
            colors: [
                "primary",
                "secondary",
                "yellow darken-2",
                "red",
                "orange",
            ],
            cycle: true,
            sliderLabel: "Start",

            closeInfo: false,
        };
    },

    methods: {
        next() {
            console.log("this.onboarding next", this.onboarding);
            console.log("this.length next", this.length);
            this.onboarding =
                this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
        },
        prev() {
            console.log("this.onboarding prev", this.onboarding);
            console.log("this.length prev", this.length);
            this.onboarding =
                this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
        },
    },

    async created() {
        const [sliderData] = await Promise.all([
            this.callApi("get", "/get_slider"),
        ]);
        if (sliderData.status == 200) {
            this.sliderData = sliderData.data;
            console.log("this.sliderData.length", this.sliderData.length);
            console.log("this.sliderData", this.sliderData);
            this.length = this.sliderData.length;
        }
    },
    computed: {
        slideHandler() {
            if (this.cycle == true) {
                console.log("play");
                this.sliderLabel = "play";
            } else {
                console.log("stop");
                this.sliderLabel = "stop";
            }
        },

        height() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 220;
                case "sm":
                    return 400;
                case "md":
                    return 500;
                case "lg":
                    return 600;
                case "xl":
                    return 800;
            }
        },
    },
};
</script>

<style scoped>
.my-element:focus {
    border: 3px solid orange;
}

:focus {
    border: 3px solid orange;
}

/*
  The :focus-within pseudo-class
  will NOT style the elements within
  the .my-element selector, like the
  normal :focus above, but will
  style the .my-element container
  when its focusable children
  receive focus.
*/
.my-element:focus-within {
    outline: 3px solid orange;
}
</style>
